import io from 'socket.io-client';
import Push from 'push.js';

import { ctiApi, makeAsyncMutationTypes } from '@/utils';
import { LOGIN } from '@/constants/action-types';

import bus from '@/utils/bus';

import handleCtiError from './handle-cti-error';
import handlePureconnectEvent from './handle-pureconnect-event';
import { consumeIntentionalDisconnect } from './intentional-disconnect';

const { FAILURE, REQUEST, SUCCESS } = makeAsyncMutationTypes(LOGIN);

const { VUE_APP_CTI_URL } = process.env;

let ctiDisconnected = false;

const disconnectMessages = {
  'transport close': 'De verbinding is onverwacht verbroken.',
  'transport error': 'Er is een fout opgetreden met de verbinding.',
  'ping timeout': 'De verbinding is verbroken door een time-out.',
  'io server disconnect': 'De verbinding is verbroken door de server.',
  'io client disconnect': 'Je hebt de verbinding zelf beëindigd.',
  'forced close': 'De verbinding is geforceerd afgesloten.',
};

export default (context, { ctiStation, isAuto }) => {
  const { commit, rootGetters } = context;

  const userEmail = rootGetters['authentication/userEmail'];

  commit(REQUEST);

  return ctiApi({
    method: 'post',
    url: '/login',
  })
    .then(({ data }) => {
      commit(SUCCESS, data.data);

      const { pureConnectorToken } = data;

      const socket = io.connect(VUE_APP_CTI_URL, {
        query: { userName: userEmail, pureConnectorToken },
      });

      socket.on('message', (message) => {
        console.log(message);

        handlePureconnectEvent(context)(message);
      });

      socket.on('disconnect', (reason) => {
        // Skip disconnect modal when the disconnect was triggered intentionally by the agent
        if (consumeIntentionalDisconnect() || reason === 'io client disconnect') {
          return;
        }

        ctiDisconnected = true;

        let errorMessage = disconnectMessages[reason] || `Reden: ${reason}.`;

        bus.$emit('show-modal', {
          message: 'CTI verbinding verbroken',
          body: `${errorMessage} Blijf even wachten, de verbinding wordt automatisch hervat.`,
          cancel: true,
          cancelText: 'Venster sluiten',
        });
      });

      socket.on('connect', () => {
        if (ctiDisconnected) {
          bus.$emit('close-modal');

          if (Push.Permission.has()) {
            Push.create('CTI verbinding hersteld', {
              body: 'De verbinding met de CTI is succesvol opnieuw tot stand gebracht.',
            });
          }
          ctiDisconnected = false;
        }
      });
    })
    .catch((error) => {
      commit(FAILURE, error);

      if (isAuto && error.response && error.response.status === 400) {
        return;
      }

      handleCtiError(commit)(error);
    });
};
